var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoBetLimit = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "fence",
    d: "M17.872,9.089l-1.4-2.1a.731.731,0,0,0-1.222,0l-1.4,2.1a.763.763,0,0,0-.128.423v1.834H11.14V9.512a.763.763,0,0,0-.128-.423l-1.4-2.1a.731.731,0,0,0-1.222,0l-1.4,2.1a.763.763,0,0,0-.128.423v1.834H4.281V9.512a.763.763,0,0,0-.128-.423l-1.4-2.1a.731.731,0,0,0-1.222,0l-1.4,2.1A.763.763,0,0,0,0,9.512V22.906a.746.746,0,0,0,.739.753h2.8a.746.746,0,0,0,.739-.753V21.44H6.859v1.466a.746.746,0,0,0,.739.753h2.8a.746.746,0,0,0,.739-.753V21.44h2.578v1.466a.746.746,0,0,0,.739.753h2.8A.746.746,0,0,0,18,22.906V9.512A.763.763,0,0,0,17.872,9.089ZM6.859,18.921H4.281V13.866H6.859v5.055Zm4.281-5.055h2.578V18.92H11.141Z",
    transform: "translate(0 -6.659)",
    fill: "#74276b"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoBetLimit);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_bet_limit.3f58798d54785ec54c8273e18d4f58b3.svg";